<template>
    <span :class="cssClass" v-on:click="edit">
        <div class="alert alert-danger" v-if="isFailed" v-html="error"></div>

        <form enctype="multipart/form-data" novalidate v-if="isInitial || isUploading">
            <h3>{{ $t('upload_file') }}</h3>
            <div class="dropbox">
                <input type="file" name="file" :disabled="isUploading" @change="filesChange($event.target.name, $event.target.files)" accept="application/pdf" class="input-file">

                <p v-if="isInitial">
                    {{ $t('drag_files_here') }}
                </p>
                <p v-if="isUploading">
                    {{ $t('uploading') }}
                </p>
            </div>
        </form>

        <h4 v-if="contents">
            <a :href="contents"><i class="fa fa-file-pdf-o fa-fw"></i>&nbsp;{{ fileName }}</a>
        </h4>

        <div class="editor mt-15" v-if="!isComplete">
            <button class="btn btn-sm btn-success" v-on:click="contents = editor" v-if="isInitial">{{ $t('save') }}</button>
            <button class="btn btn-sm" v-on:click.capture.prevent.stop="cancel">{{ $t('cancel') }}</button>
            <button class="btn btn-sm btn-danger" v-on:click="destroy">{{ $t('delete') }}</button>
        </div>
    </span>
</template>

<script>
    import { upload } from '../../file-upload.service.js';
    import widgetMixin from '../../mixins/widgetMixin.js';

    const STATUS_INITIAL = 0, STATUS_UPLOADING = 1, STATUS_COMPLETE = 2, STATUS_EDITING = 3, STATUS_FAILED = 4;

    export default {
        mixins: [widgetMixin],
        props: {
            id: Number,
            readOnly: {
                type: Boolean,
                default: true,
            },
        },
        data: function () {
            return {
                editor: null,
                error: null,
                status: null,
            }
        },
        computed: {
            fileName() {
                if (!this.contents) {
                    return null;
                }

                return this.contents.split('/').pop();
            },
            isInitial() {
                return this.status === STATUS_INITIAL;
            },
            isUploading() {
                return this.status === STATUS_UPLOADING;
            },
            isComplete() {
                return this.status === STATUS_COMPLETE;
            },
            isEditing() {
                return this.status === STATUS_EDITING;
            },
            isFailed() {
                return this.status === STATUS_FAILED;
            },
            contents: {
                set: function (value) {
                    this.widget.contents = value;
                },
                get: function () {
                    return this.widget.contents;
                }
            },
            cssClass: function () {
                var css = 'file-widget';

                if (!this.readOnly && this.isComplete) {
                    css += ' editable';
                }

                return css;
            },
        },
        methods: {
            afterSaveCallback: function () {
                this.status = STATUS_COMPLETE;
            },
            reset: function() {
                // reset form to initial state
                this.status = this.contents ? STATUS_COMPLETE : STATUS_INITIAL;
                this.error = null;
            },
            upload: function(formData) {
                // upload data to the server
                this.status = STATUS_UPLOADING;

                upload(formData)
                    .then(x => {
                        this.contents = x;
                        this.save();
                    })
                    .catch(err => {
                        this.error = err.response.data.message;
                        this.status = STATUS_FAILED;
                    });
            },
            filesChange: function(fieldName, fileList) {
                // handle file changes
                const formData = new FormData();

                if (!fileList.length) {
                    return;
                }

                // append the files to FormData
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append(fieldName, fileList[x], fileList[x].name);
                    });

                // upload it
                this.upload(formData);
            },

            edit: function (event) {
                if (this.readOnly || this.isEditing) {
                    return false;
                }

                if (this.isComplete) {
                    this.status = STATUS_EDITING;
                    event.preventDefault();
                }
            },

            cancel: function (event) {
                this.status = STATUS_COMPLETE;

                if (!this.contents) {
                    this.destroy(true);
                }
            },
        },
        mounted: function () {
            this.reset();
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/widgets/FileWidget.vue